import { render, staticRenderFns } from "./tmVisualText.vue?vue&type=template&id=159daf61&"
import script from "./tmVisualText.vue?vue&type=script&lang=js&"
export * from "./tmVisualText.vue?vue&type=script&lang=js&"
import style0 from "./tmVisualText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports